// Member order drives the Timeframe menu: backward presets narrowest to
// widest, then forward-looking, then custom
enum TimeframePreset {
  LastWeek = 'lastWeek',
  LastMonth = 'lastMonth',
  Last3Months = 'last3Months',
  ThisSchoolYear = 'thisSchoolYear',
  UpToToday = 'upToToday',
  Next2Weeks = 'next2Weeks',
  Custom = 'custom',
}

export default TimeframePreset;
